export default (that) => [
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    width: 60,
    fixed: 'right',
    align: 'center',
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'downloadFileName',
    align: 'left',
    minWidth: 200,
    title: '文件名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'downloadStatusName',
    align: 'left',
    width: 100,
    title: '状态',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
